import qs from 'qs';

export const state = () => ({
	applications: {},
	singleApplication: null,
	scroll_position: 0,
	cursor: null,
	interview_tab: false,
});

export const mutations = {
	setApplications(state: any, payload: any) {
		state.applications = payload;
	},

	setSingleApplication(state: any, payload: any) {
		state.singleApplication = payload;
	},

	setScrollPosition(state: any, payload: any) {
		state.scroll_position = payload;
	},
	setCursor(state: any, payload: any) {
		state.cursor = payload;
	},
	setInterviewTab(state: any, payload: any) {
		state.interview_tab = payload;
	},
};

export const getters = {
	getApplications: (state: any) => state.applications,
	getSingleApplication: (state: any) => state.singleApplication,
	getScrollPosition: (state: any) => state.scroll_position,
	getCursor: (state: any) => state.cursor,
	getInterviewTab: (state: any) => state.interview_tab,
};

export const actions = {
	setScrollPosition(state: any, payload: any) {
		state.commit('setScrollPosition', payload);
	},

	async fetchApplications(state: any, payload: any) {
		let params = {
			status: payload ? payload : null,
		};

		Object.keys(params).forEach((key) => {
			if (params[key] === null || params[key] === '') delete params[key];
		});

		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/job-applications', {
					params,
				})
				.then((res) => {
					state.commit('setApplications', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async fetchSingleApplication(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/job-applications/' + payload)
				.then((res) => {
					state.commit('setSingleApplication', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	revokeApplication(state: any, application_uuid: string) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put(`/api/job-applications/${application_uuid}/revoke`)
				.then((res) => {
					state.commit('setSingleApplication', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	setSingleApplication(state: any, payload: any) {
		state.commit('setSingleApplication', payload);
	},
	setCursor(state: any, payload: any) {
		state.commit('setCursor', payload);
	},
	updateInterviewTab(state: any, payload: any) {
		state.commit('setInterviewTab', payload);
	},
};
